// New file: PartyRolesList.js (modeled after index.js which is AddresstList)

import React, { useState, useEffect } from "react";
import MaterialTable from 'material-table'
import { ToastContainer, toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
// import _ from "lodash";
import ContentLoader from "react-content-loader";

import GetCompanyInfoService from "../../services/company/getCompanyInfoService";
import AddPartyRoleSettingService from "../../services/settings/AddPartyRoleSettingService";
import { getTrans as t } from "../../Localization/translations";
import PartyAddRole from "./PartyAddRole"; // New component
import EditPartyRole from "./EditPartyRole"; // New component
import axios from "axios";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";

function PartyRolesList({ onBack }) {
  const tableRef = React.createRef();

  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = () => {
    GetCompanyInfoService.getCompanySettingInfo().then((response) => {
      const rolesString = response.data.party_roles;
      const roleList = rolesString
        ? rolesString.split(",").map(role => ({
            name: role.trim(),
            status: "Active"
          }))
        : [];
      setRoles(roleList);
      setLoading(false);
    });
  };

  const saveRoles = (newRoles) => {
    const roleNames = newRoles.map(r => r.name).join(", ");
    AddPartyRoleSettingService.addPartyRoleSetting(roleNames).then((response) => {
      if (response.data.success) {
        toast.success(`${response.data.response}`);
        setRoles(newRoles);
      } else {
        toast.error(`${response.data.error}`);
      }
    });
  };

  const checkRoleDeletable = async (roleName) => {
    try {
      const response = await axios.get(`${API}company/party-roles/check-deletable/${encodeURIComponent(roleName)}/`, { headers: authHeader() });
      if (response.data.success) {
        return response.data;
      } else {
        toast.error(t(response.data.message || "Failed to check role deletability"));
        return { can_delete: false };
      }
    } catch (error) {
      console.error("Error checking role deletability:", error);
      toast.error(t("Failed to check role deletability"));
      return { can_delete: false };
    }
  };


  // const handleDelete = (roleName) => {
  //   confirmAlert({
  //     title: '',
  //     message: 'Are you sure you want to delete this Role?',
  //     buttons: [
  //       {
  //         label: 'Yes',
  //         onClick: () => {
  //           const newRoles = roles.filter(r => r.name !== roleName);
  //           saveRoles(newRoles);
  //         }
  //       },
  //       {
  //         label: 'No'
  //       }
  //     ]
  //   });
  // };

  const handleDelete = async (roleName) => {
    const result = await checkRoleDeletable(roleName);
    if (!result.can_delete) {
      toast.error(t(result.message || `Cannot delete role "${roleName}"`));
      return;
    }

    confirmAlert({
      title: '',
      message: `Are you sure you want to delete the role "${roleName}"?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            const newRoles = roles.filter(r => r.name !== roleName);
            saveRoles(newRoles);
          }
        },
        {
          label: 'No'
        }
      ]
    });
  };

  if (loading) {
    return (
      <ContentLoader
        viewBox="0 0 1000 550"
        backgroundColor="rgba(0,0,0,0.06)"
        foregroundColor="rgba(0,0,0,0.12)"
      >
        {/* Loader paths */}
      </ContentLoader>
    );
  }

  if (showAdd) {
    return (
      <PartyAddRole
        currentRoles={roles}
        onSave={(newName) => {
          const newRoles = [...roles, { name: newName, status: "Active" }];
          saveRoles(newRoles);
          setShowAdd(false);
        }}
        onCancel={() => setShowAdd(false)}
      />
    );
  }

  if (showEdit) {
    return (
      <EditPartyRole
        roleName={selectedRole}
        currentRoles={roles}
        onSave={(newName) => {
          const newRoles = roles.map(r => r.name === selectedRole ? { ...r, name: newName } : r);
          saveRoles(newRoles);
          setShowEdit(false);
        }}
        onCancel={() => setShowEdit(false)}
      />
    );
  }

  return (
    <>
      <div className="container-fluid">
      <ToastContainer />
      <div className=" page-wrapper col-md-12 filter_contract">
        <div className="mb-0">
          <div className="header pb-0">
            <div className="d-lg-flex mb-2">
              <div>
                <h5 className="mb-3">{t('Party Roles')}</h5>
              </div>
              <div className="ms-auto my-auto mt-lg-0 mt-4">
                <div className="ms-auto my-auto">
                  <div className="btn btn-primary mb-0" onClick={() => setShowAdd(true)}>
                    +&nbsp;{t('New Role')}
                  </div>
                </div>
              </div>
            </div>
            <button className="btn btn-secondary" onClick={onBack}>
              {t("Back to Settings")}
            </button>
          </div>
          <div className="body">
            <MaterialTable
              tableRef={tableRef}
              style={{
                backgroundColor: "var(--bs-table-bg)",
                borderBottomWidth: "1px",
                boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
              }}
              columns={[
                {
                  title: `${t("Role Name")}`,
                  field: "name",
                  render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Role Name")}</div><div>{rowData.name}</div></>,
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left"
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12
                  }
                },
              ]}
              data={roles}
              actions={[
                {
                  icon: () => <span><img src={process.env.PUBLIC_URL + '/static/images/ic-edit.svg'} alt="Edit" /></span>,
                  tooltip: "Edit",
                  onClick: (event, rowData) => {
                    setSelectedRole(rowData.name);
                    setShowEdit(true);
                  }
                },
                {
                  icon: () => <img src={process.env.PUBLIC_URL + "/static/images/ic-delete.svg"} alt="delete" />,
                  tooltip: "Delete",
                  onClick: (event, rowData) => {
                    handleDelete(rowData.name);
                  }
                }
              ]}
              options={{
                headerStyle: {
                  backgroundColor: "white",
                  color: "#245C7F",
                  fontSize: 12,
                },
                rowStyle: (rowData, index) => {
                  if (index % 2) {
                    return { backgroundColor: "#fff" }
                  }
                },
                sorting: true,
                search: false,
                toolbar: false,
                paging: false, // Since few roles
                actionsColumnIndex: -1,
              }}
            />
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default PartyRolesList;